﻿import { StaticAirport } from '../../static/static-airports';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';
import { AirportInfo } from '../features/home/hooks/use-flight-position';

export function getId(airport: StaticAirport | null | undefined): string {
    if (!airport) {
        return 'N/A';
    }
    return airport.icao || airport.iata || airport.faa || 'N/A';
}

export function createAirportExclusionFilters(airports: AirportInfo[] | null | undefined): CompositeFilterDescriptor {
    const filters = [];
    if (!airports) {
        return { logic: 'and', filters: [] };
    }
    for (const airport of airports) {
        if (airport.icao && airport.icao.trim() !== '') {
            filters.push({
                field: 'icao',
                operator: 'neq',
                value: airport.icao
            });
        }

        if (airport.iata && airport.iata.trim() !== '') {
            filters.push({
                field: 'iata',
                operator: 'neq',
                value: airport.iata
            });
        }
    }

    return {
        logic: 'and',
        filters: filters
    };
}
